/**
 * Presentation helpers for the read-time adoption layer (Contract 7).
 */

export const SHARED_USAGE_NOTE_SHORT =
  "This skill name is shared with other skills; count reflects combined usage, not this skill alone.";
export const SHARED_USAGE_NOTE_LONG =
  "This skill's name is duplicated elsewhere in the catalog. Usage reflects the combined total of active users across all skills with this name.";

/**
 * Render Contract 7's `dataThroughDate` ("YYYY-MM-DD") as a readable date.
 *
 * Parses the components explicitly instead of `new Date(iso)`: the spec parses a
 * date-ONLY string as UTC midnight, so in any negative-offset timezone
 * `toLocaleDateString()` renders the PREVIOUS day — "2026-08-01" would display as
 * Jul 31 across the US. Building the Date from local components avoids that shift.
 * (The `formatDate` helpers on the card and list view take full ISO timestamps with
 * a `Z`, so they are not affected; this one is.)
 *
 * Returns "" for anything unparseable so callers can omit the caption entirely
 * rather than surface "Invalid Date" to users.
 */
export function formatDataThroughDate(dataThroughDate: string): string {
  const [year, month, day] = dataThroughDate.split("-").map(Number);
  if (!year || !month || !day) return "";
  const parsed = new Date(year, month - 1, day);
  if (isNaN(parsed.getTime())) return "";
  return parsed.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
